import { styled } from '@clickcease/cc-client-components-lib'

export const ProfileSectionStyled = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '24px 20px',
  marginRight: '32px',
})

export const ProfileSectionTitle = styled('div', {
  display: 'flex',
  fontFamily: 'Open Sans',
  fontWeight: '$rb',
  margin: '20px 0px 0xpx 24px',
  fontSize: '$h1',
  color: '$mainTextColor',
})

export const ProfileSectionPhoneWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$16',

  ['.phone-input-container']: {
    fontWeight: '$l',
    fontSize: '$md',
    height: '30px',
  },

  '.react-tel-input': {
    height: '32px',
    color: '#9B9B9B',

    '.flag-dropdown': {
      width: '40px',
      backgroundColor: '#ffffff',
      border: '1px solid $lightNeutral',
      borderRight: 'none',
    },

    '.form-control': {
      width: '250px',
      height: '32px',
      border: '1px solid $lightNeutral',
    },
  },
})

export const ProfileSectionPhoneTitle = styled('div', {
  color: '$black',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '5px',
})

export const PasswordWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const PasswordEditButton = styled('div', {
  cursor: 'pointer',
  marginTop: '$5',
  color: 'rgba(225, 36, 104, 1)',
  fontWeight: '$r',
  fontSize: '$md',
  display: 'flex',

  ['> svg']: {
    width: '17px',
    height: '16px',
  },
})

export const PasswordButtonText = styled('div', {
  lineHeight: '17px',
  marginLeft: '8px',
})
